module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.3-81.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.3.md
// module id = 499
// module chunks = 346